import SearchPinReport from "../../Component/EPin/SearchPin";
const SearchPinPage = () => {
  return (
    <div className='page-body'>
      <SearchPinReport />
    </div>
  )
}

export default SearchPinPage